import { WEB_COMPONENT_ALERTS_DETAILS_PANEL } from '../webcomponents.constants';
import { AlertsDetailsPanelComponent } from './component/AlertsDetailsPanelComponent';

export { AlertsDetailsPanelComponent };

window.customElements.define(WEB_COMPONENT_ALERTS_DETAILS_PANEL, AlertsDetailsPanelComponent);
